module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"register":"Cadastrar","description.create":"Conecte-se com a {acquirer} de forma segura e eficiente através do novo processo de autenticação Connect Auth."},"en-US":{"register":"Register","description.create":"Connect securely and efficiently with {acquirer} through the new Connect Auth authentication process."}}')
  delete Component.options._Ctor
}
